import React from "react";
import ReportLayer from "../components/ReportLayer";
import Breadcrumb from "../components/Breadcrumb";

const ReportPage = () => {
  return (
  
  <>

  <Breadcrumb title={"Reports"}/>
  
  <ReportLayer />
  </>
);
};

export default ReportPage;
